import { WarningAmberOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilState, useRecoilValue } from "recoil";

import { FramerTooltip } from "@ryde/controls";
import { SelectedRowsToggleWrapper } from "@ryde/layout";
import { useGlobalEffectActions, usePageContext } from "@ryde/redux";
import {
  newIncidentsNewStatusTotalCountRideMapSF,
  showOnlyRidesWithNewIncidentsAtomFamily,
  TOOLTIP_DELAY_BUTTONS,
  useHasPermissions,
  useSystemParams,
} from "@ryde/shared";

export const LiveMapNewIncidentsToggle: FC = () => {
  const { entity } = usePageContext();
  const { t } = useTranslation();
  const totalNew = useRecoilValue(
    newIncidentsNewStatusTotalCountRideMapSF(entity),
  );
  const [isActive, setIsActive] = useRecoilState(
    showOnlyRidesWithNewIncidentsAtomFamily(entity),
  );
  const { resetPaginationAppEvent } = useGlobalEffectActions();
  const { hasPermissions: canReadIncidents } = useHasPermissions({
    entity: "incident",
    action: "read",
  });
  const { enableIncidents } = useSystemParams();

  const handleToggle = useEvent(() => {
    resetPaginationAppEvent();
    setIsActive(prev => !prev);
  });

  if (!enableIncidents || !canReadIncidents || totalNew < 1) {
    return null;
  }

  return (
    <SelectedRowsToggleWrapper>
      <FramerTooltip
        content={t("rideMap.SHOW_ONLY_RIDES_WITH_NEW_INCIDENTS")}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <Button
          className={clsx("selected-rows-button", { active: isActive })}
          variant="outlined"
          size="small"
          onClick={handleToggle}
          aria-pressed={isActive}
        >
          <WarningAmberOutlined className="selected-rows-icon" />
          <strong>{totalNew}</strong>
        </Button>
      </FramerTooltip>
    </SelectedRowsToggleWrapper>
  );
};
